import { sendRequest } from "../api"
import { RESET_STATE, SET_OPTION } from "../constant-types"

const getDefaultState = () => {
    return {
        options : []
    }
}
export default ({
    namespaced: true, //
    // variable
    state: getDefaultState(),
    // must syncronous
    mutations: {
        [RESET_STATE](state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.assign(state, getDefaultState())
        },
        [SET_OPTION](state, payload) {
            state.options = payload
        }

    },
    // can async
    actions: {
        loadOptions({commit}) {
            return sendRequest('account-class/option',{}, 'get', (success) => commit(SET_OPTION, success), ()=>{}, ()=>{})
        }
    },
    // call variable with custom display
    getters: {

    }
})
